import { useState, useEffect, useRef } from 'react';
import './App.css';
import bg from "./bg.mp4"

const styles = `

.App {
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

section {
  border-radius: 20px;
  background: rgba(250, 250, 250, 0.95);
  margin: 2% 5%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: monospace;
  font-size: 18px;
  padding: 30px;
  backdrop-filter: blur(10px);
}

@media (min-width: 768px) {
  section {
    margin: 5% 15%;
    font-size: 20px;
  }
}

.intro-text {
  text-align: left;
  margin: 5% 10%;
  line-height: 1.6;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 15px;
  border-left: 4px solid #667eea;
}

.intro-text p {
  margin: 10px 0;
}

.intro-text strong {
  color: #667eea;
}

.gameBoard {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
  margin: 20px 0;
}

@media (max-width: 768px) {
  .gameBoard {
    flex-direction: column;
    align-items: center;
  }
}

.player-label {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}


.meter {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.meter-box {
  height: 80px;
  width: 60%;
  max-width: 300px;
  border-radius: 40px;
  text-align: center;
  border: 4px solid #667eea;
  box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

@media (max-width: 480px) {
  .meter-box {
    width: 90%;
    height: 60px;
    font-size: 18px;
  }
}

#number-board {
  border-collapse: separate;
  border-spacing: 10px;
}

#number-board td input {
  width: 80px;
  height: 80px;
  font-size: 24px;
  font-weight: bold;
  border-radius: 10px;
}

@media (max-width: 480px) {
  #number-board td input {
    width: 60px;
    height: 60px;
    font-size: 18px;
  }
}

.bot, .user {
  pointer-events: none;
  transition: all 0.3s ease;
}

.user.highlight {
  border: 3px solid #4CAF50;
  box-shadow: 0 0 20px rgba(76, 175, 80, 0.3);
  pointer-events: initial;
  border-radius: 15px;
  padding: 20px;
}

.bot.highlight {
  border: 3px solid #FF5722;
  box-shadow: 0 0 20px rgba(255, 87, 34, 0.3);
  border-radius: 15px;
  padding: 20px;
}

.pressed {
  background: #667eea !important;
  transform: scale(0.95) !important;
  box-shadow: 0 0 20px rgba(102, 126, 234, 0.6) !important;
}

.number-slide-enter {
  animation: slideIn 0.5s forwards;
}

@keyframes slideIn {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.game-over {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.final-score {
  background: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 15px;
  border-left: 4px solid #667eea;
}

.final-score h2 {
  color: #667eea;
  margin: 0 0 10px 0;
}

.score-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 10px;
}

@media (max-width: 480px) {
  .score-card {
    flex-direction: column;
    text-align: center;
  }
}

.score-display {
  font-size: 18px;
  font-weight: bold;
}

.score-label {
  color: #667eea;
}

.score-value {
  color: #333;
}

.timer-display {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.timer-label {
  color: #667eea;
}

.timer-value {
  font-weight: bold;
  color: #333;
  padding: 5px 10px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 5px;
}

.timer-warning {
  background: rgba(255, 87, 34, 0.2) !important;
  color: #FF5722 !important;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.time-bank {
  color: #4CAF50;
  font-size: 12px;
  font-weight: bold;
}

.bot-thinking {
  color: #FF5722;
  font-style: italic;
  animation: thinking 1.5s infinite;
}

@keyframes thinking {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = styles;
  document.head.appendChild(styleElement);
}

function App() {
  const [isIntro, toggleIntro] = useState(true)
  const [botsTurn, toggleBotsTurn] = useState(false)
  const [mainArr, setMainArr] = useState([])
  const [userStreak, setUserStreak] = useState([])
  const [meterVal, setMeterVal] = useState('')
  const [gameOver, reloadGame] = useState(false)
  const [score, setScore] = useState(0)
  const [userTimeLeft, setUserTimeLeft] = useState(10)
  const [userTimeBank, setUserTimeBank] = useState(0) // Bonus time accumulated
  const [isGameStarted, setIsGameStarted] = useState(false)
  const [shuffledNumbers, setShuffledNumbers] = useState([])

  const timerRef = useRef(null)

  // Initialize shuffled numbers when game starts
  useEffect(() => {
    if (isGameStarted && shuffledNumbers.length === 0) {
      setShuffledNumbers(Array.from({ length: 9 }, (_, i) => i + 1)
        .sort(() => Math.random() - 0.5))
    }
  }, [isGameStarted])

  useEffect(() => {
    if (botsTurn) {
      clearTimer()
      setTimeout(() => {
        botsPlay()
      }, 1000)
    } else if (isGameStarted && !gameOver) {
      startUserTimer()
    }
  }, [botsTurn, isGameStarted])

  useEffect(() => {
    if (gameOver) {
      clearTimer()
      console.log("Game Over - Final Score:", score)
    }
  }, [gameOver])

  function startUserTimer() {
    clearTimer()
    const totalTime = 10 + userTimeBank
    setUserTimeLeft(totalTime)

    timerRef.current = setInterval(() => {
      setUserTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearTimer()
          reloadGame(true)
          return 0
        }
        return prevTime - 1
      })
    }, 1000)
  }

  function clearTimer() {
    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = null
    }
  }

  function gameOn(e) {
    if (botsTurn || gameOver) return

    e.target.classList.add("pressed")
    setTimeout(() => {
      e.target.classList.remove("pressed")
    }, 100)

    const pressedValue = e.target.value
    setMeterVal(pressedValue)

    // Shuffle numbers after each press
    setShuffledNumbers(Array.from({ length: 9 }, (_, i) => i + 1)
      .sort(() => Math.random() - 0.5))

    if (mainArr.length === 0) {
      // First move - user starts
      setMainArr([pressedValue])
      setScore(1)
      setUserStreak([])

      // Calculate bonus time
      const bonusTime = Math.max(0, userTimeLeft - 1)
      setUserTimeBank(bonusTime)

      clearTimer()
      toggleBotsTurn(true)
    } else {
      const userArr = userStreak.concat(pressedValue)
      const sequence = mainArr.slice(0, userArr.length).map(String)

      if (userArr.length > mainArr.length) {
        // User completed sequence and added new number
        setMainArr(prevArr => [...prevArr, pressedValue])
        setScore(prevScore => prevScore + 1)
        setUserStreak([])

        // Calculate bonus time
        const bonusTime = Math.max(0, userTimeLeft - 1)
        setUserTimeBank(bonusTime)

        clearTimer()
        toggleBotsTurn(true)
        return
      }

      const isCorrect = userArr.every((value, index) => value === sequence[index])
      if (isCorrect) {
        setUserStreak(userArr)
      } else {
        clearTimer()
        reloadGame(true)
      }
    }
  }

  function botsPlay() {
    const sequence = mainArr.slice()
    let index = 0

    function simulateBotTurn() {
      if (index < sequence.length) {
        setTimeout(() => {
          const pressedValue = sequence[index]
          setMeterVal(pressedValue)
          const botButton = document.querySelector(`.bot input[value='${pressedValue}']`)
          if (botButton) {
            botButton.classList.add("pressed")
            setTimeout(() => { botButton.classList.remove("pressed") }, 100)
          }

          index++
          simulateBotTurn()
        }, 500)
      } else {
        const newNumber = Math.floor(Math.random() * 9) + 1

        setTimeout(() => {
          setMeterVal(newNumber)
          setMainArr(prevArr => [...prevArr, newNumber])
          toggleBotsTurn(false)
          const botButton = document.querySelector(`.bot input[value='${newNumber}']`)
          if (botButton) {
            botButton.classList.add("pressed")
            setTimeout(() => { botButton.classList.remove("pressed") }, 100)
          }
        }, 500)
      }
    }
    simulateBotTurn()
  }

  function startGame() {
    toggleIntro(false)
    setIsGameStarted(true)
    setMainArr([])
    setUserStreak([])
    setScore(0)
    setUserTimeBank(0)
    setUserTimeLeft(10)
    reloadGame(false)
    toggleBotsTurn(false)
  }

  function resetGame() {
    clearTimer()
    setMainArr([])
    setUserStreak([])
    setScore(0)
    setUserTimeBank(0)
    setUserTimeLeft(10)
    reloadGame(false)
    toggleBotsTurn(false)
    setIsGameStarted(true)
    setShuffledNumbers(Array.from({ length: 9 }, (_, i) => i + 1)
      .sort(() => Math.random() - 0.5))
  }

  return (
    <div className="App">
        <video id="background-video" loop autoPlay muted>
          <source src={bg} type="video/mp4" />
          <source src={bg} type="video/ogg" />
        Your browser does not support the video tag.
      </video>

      <section>
        <ScoreCard score={score} timeLeft={userTimeLeft} timeBank={userTimeBank} botsTurn={botsTurn} />
        {
          gameOver ?
            <>
              <Meter meterVal={meterVal} gameOver={gameOver} mainArr={mainArr} userStreak={userStreak} />
              <GameOver score={score} resetGame={resetGame} />
            </> :
            (isIntro ?
              <Intro startGame={startGame} /> :
              <>
                <Meter meterVal={meterVal} gameOver={gameOver} mainArr={mainArr} userStreak={userStreak} />
                <Board gameOn={gameOn} botsTurn={botsTurn} shuffledNumbers={shuffledNumbers} />
              </>
            )
        }
      </section>

    </div>
  )
}

export default App

function Intro({ startGame }) {
  return (
    <div>
      <h1>Welcome to Memory Master!</h1>
      <div className="intro-text">
        <p><strong>How to Play:</strong></p>
        <p>🎯 <strong>You start first!</strong> Click any number to begin the sequence.</p>
        <p>🤖 The bot will repeat your sequence and add a new number.</p>
        <p>🧠 Your job is to repeat the entire sequence (including the bot's new number) and add your own number.</p>
        <p>⏱️ You have 10 seconds per turn. Any leftover time gets added to your next turn!</p>
        <p>🎮 Keep the sequence going as long as you can. The longer the sequence, the higher your score!</p>
        <p><em>The numbers shuffle randomly each game to keep you on your toes!</em></p>
      </div>
      <button className='button-49' onClick={startGame}>
        <span>START GAME</span>
      </button>
    </div>
  )
}

function Meter({ meterVal, gameOver, mainArr, userStreak }) {
  let displayValue = meterVal
  let className = 'meter-box number-slide-enter'

  if (gameOver) {
    const correctValue = mainArr[userStreak.length] || ''
    displayValue = `${meterVal} (Expected: ${correctValue})`
    className += ' game-over'
  }

  return (
    <div className='meter'>
      <div className={className}>{displayValue}</div>
    </div>
  )
}

function Board({ gameOn, botsTurn, shuffledNumbers }) {
  return (
    <div className='gameBoard'>
      <div className={botsTurn ? 'bot highlight' : "bot"}>
        <div className="player-label">🤖 BOT</div>
        {Table(null, shuffledNumbers)}
      </div>
      <div className={botsTurn ? 'user' : 'user highlight'}>
        <div className="player-label">👤 YOU</div>
        {Table(gameOn, shuffledNumbers)}
      </div>
    </div>
  )
}

function Table(gameOn, shuffledNumbers) {
  const rows = 3
  const cols = 3
  let index = 0

  return (
    <table id="number-board">
      <tbody>
        {Array.from({ length: rows }, (_, i) => (
          <tr key={i}>
            {Array.from({ length: cols }, (_, j) => (
              <td key={i * cols + j + 1}>
                <input
                  className='button-53'
                  onClick={gameOn}
                  type="button"
                  value={shuffledNumbers[index++]}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

function GameOver({ score, resetGame }) {
  return (
    <div className='game-over'>
      <h1>🎮 Game Over!</h1>
      <div className="final-score">
        <h2>Final Score: {score}</h2>
        <p>You managed to remember {score} numbers in sequence!</p>
        {score >= 10 && <p>🏆 Excellent memory skills!</p>}
        {score >= 7 && score < 10 && <p>🎯 Great job!</p>}
        {score >= 5 && score < 7 && <p>👍 Good effort!</p>}
        {score < 5 && <p>💪 Keep practicing!</p>}
      </div>
      <button className='button-53' onClick={resetGame}>
        <span>PLAY AGAIN</span>
      </button>
    </div>
  )
}

function ScoreCard({ score, timeLeft, timeBank, botsTurn }) {
  return (
    <div className="score-card">
      <div className="score-display">
        <span className="score-label">Score: </span>
        <span className="score-value">{score}</span>
      </div>
      {!botsTurn && (
        <div className="timer-display">
          <span className="timer-label">Time: </span>
          <span className={`timer-value ${timeLeft <= 3 ? 'timer-warning' : ''}`}>
            {timeLeft}s
          </span>
          {timeBank > 0 && (
            <span className="time-bank">
              (+{timeBank}s bonus)
            </span>
          )}
        </div>
      )}
      {botsTurn && (
        <div className="bot-thinking">
          <span>🤖 Bot is thinking...</span>
        </div>
      )}
    </div>
  )
}